<template>
  <v-container class="px-8 pt-0 pb-15" style="max-width: 500px">
    <v-row no-gutters class="text-h4 font-weight-bold py-6">
      <v-col align-self="center" class="main-font secondary--text">Ideas</v-col
      ><v-col cols="auto" align-self="center" class="pl-5">
        <v-btn icon @click="dialogCreateIdea = true">
          <v-icon size="30" color="secondary">mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters class="secondary--text">
      Add and like ideas you want us to work on.
    </v-row>

    <v-tabs v-model="tab" active-class="selected-tab" hide-slider class="my-4">
      <v-tab
        v-for="(item, index) in items"
        :key="item"
        class="text-none rounded-pill"
        style="opacity: 0.5"
      >
        <v-container>
          <v-row no-gutters class="text-h6 font-weight-light secondary--text">{{
            item
          }}</v-row>
          <v-fade-transition>
            <v-row no-gutters justify="center" v-if="tab === index">
              <div class="point-tab"></div></v-row
          ></v-fade-transition>
        </v-container>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="pb-16 transparent">
      <v-tab-item>
        <transition-group name="list-complete" style="width: 100%">
          <v-row
            no-gutters
            v-for="idea in ideasToComplete"
            :key="idea.id"
            class="list-complete-item my-4"
          >
            <v-col
              cols="auto"
              class="pr-4"
              @click="
                toggleLove(
                  {
                    itemId: idea.id,
                    target: 'ideas',
                    self,
                  },
                  idea
                )
              "
            >
              <v-chip
                small
                class="px-2"
                dark
                color="accent"
                :outlined="!idea.loversId.includes(self.id)"
                >{{ idea.numberOfLovers }}
                <v-icon class="ml-2 pr-1">{{
                  idea.loversId.includes(self.id)
                    ? "mdi-heart"
                    : "mdi-heart-outline"
                }}</v-icon>
              </v-chip>
            </v-col>
            <v-col
              @click="
                toggleLove(
                  {
                    itemId: idea.id,
                    target: 'ideas',
                    self,
                  },
                  idea
                )
              "
              ><v-row no-gutters>{{ idea.text }}</v-row
              ><v-row no-gutters class="text-caption grey--text"
                >{{ idea.userNickname ? `By ${idea.userNickname}, ` : ""
                }}{{ handleISOToRelativeTime(idea.createdAt.toDate()) }}</v-row
              ></v-col
            ><v-col cols="auto" v-if="self.id === idea.userId" class="mt-n1"
              ><v-btn icon @click="$store.dispatch('ideas/deleteIdea', idea.id)"
                ><v-icon>mdi-delete-outline</v-icon></v-btn
              ></v-col
            >
          </v-row>
        </transition-group>
      </v-tab-item>

      <v-tab-item>
        <transition-group name="list-complete" style="width: 100%">
          <v-row
            no-gutters
            v-for="idea in ideasCompleted"
            :key="idea.id"
            class="list-complete-item my-4"
            ><v-col
              cols="auto"
              class="pr-4"
              @click="
                toggleLove(
                  {
                    itemId: idea.id,
                    target: 'ideas',
                    self,
                  },
                  idea
                )
              "
            >
              <v-chip
                small
                class="px-2"
                dark
                color="accent"
                :outlined="!idea.loversId.includes(self.id)"
                >{{ idea.numberOfLovers }}
                <v-icon class="ml-2 pr-1">{{
                  idea.loversId.includes(self.id)
                    ? "mdi-heart"
                    : "mdi-heart-outline"
                }}</v-icon>
              </v-chip>
            </v-col>
            <v-col
              @click="
                toggleLove(
                  {
                    itemId: idea.id,
                    target: 'ideas',
                    self,
                  },
                  idea
                )
              "
              ><v-row no-gutters class="secondary--text">{{ idea.text }}</v-row
              ><v-row no-gutters class="text-caption grey--text">{{
                handleISOToRelativeTime(idea.updatedAt.toDate())
              }}</v-row></v-col
            ><v-col cols="auto"
              ><v-icon color="primary">mdi-check</v-icon></v-col
            >
          </v-row>
        </transition-group>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog
      v-model="dialogCreateIdea"
      content-class="dialog-description"
      overlay-opacity="0.2"
      max-width="300"
      transition="dialog-top-transition"
      origin="center top"
      class="rounded-xl"
    >
      <v-card class="rounded">
        <v-row no-gutters justify="center">
          <v-textarea
            color="primary"
            placeholder="Write your idea"
            background-color="white"
            v-model="text"
            :rows="2"
            rounded
            hide-details
            autofocus
          ></v-textarea>
        </v-row>

        <v-row no-gutters justify="end">
          <v-btn
            class="ma-4 text-none rounded-pill"
            color="primary"
            depressed
            @click="createIdea()"
            >Add</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { ISOToRelativeTime } from "@/utils/dates.js";

export default {
  computed: {
    ...mapState("self", ["self"]),
    ...mapState("ideas", ["ideas"]),
    ideasToComplete() {
      return this.ideas
        .filter(function (i) {
          return i.status === "to-complete";
        })
        .sort(function (a, b) {
          return b.numberOfLovers - a.numberOfLovers;
        });
    },
    ideasCompleted() {
      return this.ideas
        .filter(function (i) {
          return i.status === "completed";
        })
        .sort(function (a, b) {
          return b.numberOfLovers - a.numberOfLovers;
        });
    },
  },
  mounted() {
    this.$store.dispatch("ideas/getIdeas");
  },
  data() {
    return {
      dialogCreateIdea: false,
      text: "",
      tab: 0,
      items: ["Ideas", "Implemented"],
    };
  },
  methods: {
    createIdea() {
      if (this.text === "") return;
      this.$store.dispatch("ideas/createIdea", {
        text: this.text,
        userId: this.self.id,
        userNickname: this.self.nickname,
        numberOfLovers: 0,
        status: "to-complete",
        loversId: [],
      });
      this.dialogCreateIdea = false;
      this.text = "";
    },
    toggleLove(params, idea) {
      let newIdea = idea;
      if (newIdea.loversId.includes(this.self.id)) {
        newIdea.loversId = newIdea.loversId.filter((i) => {
          return i !== this.self.id;
        });
        newIdea.numberOfLovers -= 1;
      } else {
        newIdea.loversId.push(this.self.id);
        newIdea.numberOfLovers += 1;
      }
      this.$store.dispatch("level/updateLevel", {
        field: "idea",
        value: true,
      });
      this.$store.commit("ideas/updateIdea", newIdea);
      this.$store.dispatch("lovers/toggleLove", params);
    },
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
  },
};
</script>

<style >
</style>